import React, { useEffect} from 'react';
import {useAppDispatch} from "../DAL/store";
import {useAppSelector} from "../DAL/store";
import StickyBuyFromDealer from "../components/sticky-buy-from-dealer";
import OpeningDetails from "../components/opening-details";
import SystemBuilderOptions from "../components/system-builder-options";
import {InitUserState} from "../services/logic-helper";


/**
 * the entry point
 */
const App: React.FC = () => {

    const dispatch = useAppDispatch();
    const SBL_BuilderPage = useAppSelector((store) => store.SBL_BuilderPage);
    const CategoryList = useAppSelector((store) => store.CategoryList);
    const ProductList = useAppSelector((store) => store.ProductList);
    const PageWasLoad = useAppSelector((store) => store.PageWasLoad);


    /**
     * On page load -> set selected items by URL's params
     */
    useEffect(() => {
        (async() => {
            if(!PageWasLoad){
                await InitUserState(CategoryList,
                                    SBL_BuilderPage.sbl_BuilderPageProduct_ProductList,
                                    ProductList,
                                    SBL_BuilderPage.sbl_BuilderPagePresetList,
                                    SBL_BuilderPage,
                                    dispatch);
            }
        })()
    }, [SBL_BuilderPage,CategoryList,dispatch,ProductList,PageWasLoad]);

    return (
        <div className="bg-gray-100 text-gray-700 flex flex-col min-h-screen pb-10">
            <div className="waves-box-lg mx-auto px-5 md:px-12">

                <OpeningDetails />

                <div className="md:flex">
                    <div className="flex-1">
                        <div className="mb-10" style={{minHeight:"400px"}}>
                            <div className="md:flex items-center items-start">

                                <SystemBuilderOptions />

                                <StickyBuyFromDealer />

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    );
};

export default App;

